import moment from 'moment'
import { TransactionReportType } from 'src/components/ReportTransactionsBoxAndLinks/reportTypes'
import { makeBaseTransactionsSchema } from 'src/components/TransactionsListFilter/transactionsFilter.schema'
import {
  TransactionDateType,
  TransactionReceiptRecoveryStatus,
  TransactionReceiptStatus,
  TransactionSort,
} from 'src/models/transaction.models'
import { accountingReviewReportsUrl } from 'src/navigation/urls'

interface AccountingPeriodBounds {
  readonly localStartDate: string
  readonly localEndDate: string
  readonly startsAt: string
  readonly endsAt: string
}

export const getReceiptRecoveryTransactionsUrl = (
  status: TransactionReceiptRecoveryStatus,
  period: AccountingPeriodBounds,
): string => {
  const filters = makeBaseTransactionsSchema({
    context: TransactionReportType.AccountingTransactions,
    expenseCategories: [],
    sort: TransactionSort.dateClearDesc,
  })
  const query = filters.stringifyFilters({
    dateType: TransactionDateType.Clear,
    receiptRecoveryStatus: new Set([status]),
    since: moment(period.localStartDate),
    until: moment(period.localEndDate).subtract(1, 'day'),
    sinceClearedAtTimestamp: period.startsAt,
    untilClearedAtTimestamp: period.endsAt,
  })

  return `${accountingReviewReportsUrl()}?${query}`
}

export const getMissingReceiptTransactionsUrl = (
  period: AccountingPeriodBounds,
): string => {
  const filters = makeBaseTransactionsSchema({
    context: TransactionReportType.AccountingTransactions,
    expenseCategories: [],
    sort: TransactionSort.dateClearDesc,
  })
  const query = filters.stringifyFilters({
    dateType: TransactionDateType.Clear,
    receiptStatus: new Set([TransactionReceiptStatus.Missing]),
    since: moment(period.localStartDate),
    until: moment(period.localEndDate).subtract(1, 'day'),
  })

  return `${accountingReviewReportsUrl()}?${query}`
}
